import React, { useEffect, useState, useMemo } from "react";
import { useAppDispatch, useAppSelector, usePromoCode } from "@/hooks";
import { useRouter } from "next/router";
//
import { Box, FlexDiv } from "@/components/Atoms/Box";
import Image from "@/components/Atoms/Image";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import ImageBox from "@/components/Molecules/ImageBox";
import RegisterForm from "@/components/Organisms/RegisterForm";
import SuccessModal from "@/components/Organisms/SuccessModal";
//
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V2";
import { generateUrlArguments, getAdsetParams, timezone } from "@/utils";
import { HOME_LINK } from "@/constants/URLs";
import { useRegisterForm } from "@/hooks";
import { saveLead, postPackageSave } from "@/redux/LandingPageReducer";
//
import {
  BlueBox,
  DynamicContentHtml,
  FormBox,
  FormFieldBox,
  GradientSection,
  IconRing,
  LHSSection,
  LogoBox,
  RHSSection,
  StyledSeparator,
  TextAreaBox,
  TopContainer,
} from "./style";
import FormInputs from "../CorporatePartnerform/FormInput";

import { mapPartnershipProgramData } from "../mapPartnershipProgramData";
import usePaymentForm from "@/components/Organisms/PartnerForm/usePaymentForm";
//
function TopSection(props) {
  const router = useRouter();
  const {
    countryCodes = {},
    data,
    topRef,
    isMobile,
    width,
    goalPlaceholder,
    isCorporatePartnership,
    isWellnessCampaignPage,
    isOldUserReactivationPage,
    isVisaMastercardPartnership,
    acceptCoupon,
    acceptReferral,
    companyNamePlaceholder,
    emailPlaceholder,
    mobilePlaceholder,
    namePlaceHolder,
    promoCodePlaceholder,
    selectedPackagePlaceholder,
    showCompanyNameField,
    showEmailField,
    showGoalField,
    showNameField,
    showPhoneField,
    showCVIDField,
    showSelectPackage,
    defaultSelectedGoal,
    slug,
  } = props || {};
  const dispatch = useAppDispatch();
  const [leadData, setLeadData] = useState(null);

  const _services = data?.forms?.services?.filter(
    (service) => service?.slugs?.length > 0
  );
  const [serviceActive, setServiceActive] = useState(0);

  const { logoData, staticGoalOptions } = mapPartnershipProgramData(data, slug);

  let urlParams = "";
  if (typeof window !== "undefined") {
    urlParams = window.location.search;
  }

  let urlsArguments = getAdsetParams({
    urlParams,
    adsetValue: data?.partner_detail?.adset_name,
    isPartnerWebsite: !isOldUserReactivationPage,
    isOldUserReactivationPage: isOldUserReactivationPage,
  });

  if (isWellnessCampaignPage) {
    urlsArguments = generateUrlArguments(
      urlParams,
      {
        lead_via_main_website: true,
      },
      {
        adset_name: "wellness_page",
      }
    );
  }

  const fields = useMemo(
    () => ({
      ...(showNameField && { name: "" }),
      ...(showCVIDField && { cvid: "" }),
      ...(showPhoneField && {
        countryCode: countryCodes?.default?.code || "+91",
        mobile: "",
      }),
      ...(showEmailField && { email: "" }),
      ...(showCompanyNameField && { companyName: "" }),
      ...(showGoalField && { goal: defaultSelectedGoal || "" }),
      ...(acceptReferral && { referral: "" }),
      ...(acceptCoupon && { promoCode: "" }),
      goalValue: "",
    }),
    [
      showNameField,
      showCVIDField,
      showPhoneField,
      showEmailField,
      showCompanyNameField,
      showGoalField,
      acceptReferral,
      acceptCoupon,
      showGoalField,
    ]
  );

  // STATE MANAGEMENT:
  const {
    inputs,
    showSuccessModal,
    isLoading,
    handleBlur,
    handleChange,
    handleSelectChange,
    onSubmitCallback,
    onShowCallbackModal,
    onHideCallbackModal,
    applyPromoCode,
    isPromoCodeApplied,
    isPromoCodeChecking,
    promoCodeData,
    removeAppliedPromoCode,
    promoCodeButtonText,
  } = useRegisterForm(fields);

  const {
    name,
    countryCode,
    mobile,
    email,
    companyName,
    goal,
    referral,
    promoCode,
    promoCodeError,
    cvid,
  } = inputs;

  // HANDLE PAYMENT
  const { openPaymentPage } = usePaymentForm();

  useEffect(() => {
    if (showSuccessModal === true) {
      setTimeout(() => {
        onHideCallbackModal(() => {});
      }, 10000);
    }
  }, [showSuccessModal]);

  // CAPTURE LEAD
  const onBlur = () => {
    const apiData = {
      is_lead: true,
      ...(showNameField && { name }),
      ...(showCVIDField && { club_vistara_id: cvid }),
      ...(showPhoneField && mobile && { phone_prefix: countryCode, mobile }),
      ...(showEmailField && email && { email }),
      ...(showCompanyNameField && companyName && { company_name: companyName }),
      package_slug: goal || data?.hero_signup_primary_pricing?.package_slug,
      timezone: timezone,
      ...(acceptReferral && { referral }),
      ...(!isWellnessCampaignPage &&
        !isOldUserReactivationPage && { lead_via_partner_website: true }),
      urls_arguments: urlsArguments,
    };

    dispatch(saveLead({ data: apiData }));
  };
  const submitCallbackRequest = () => {
    let apiData = {
      is_callback_request: true,
      ...(showNameField && { name }),
      ...(showCVIDField && { club_vistara_id: cvid }),
      ...(showPhoneField && { phone_prefix: countryCode, mobile }),
      ...(showEmailField && { email }),
      ...(showCompanyNameField && { company_name: companyName }),
      urls_arguments: urlsArguments,
      timezone,
      package_slug: goal || data?.hero_signup_primary_pricing?.package_slug,
      timezone: timezone,
      ...(!isOldUserReactivationPage &&
        !isWellnessCampaignPage && {
          lead_via_partner_website: true,
        }),
      ...(isCorporatePartnership && {
        company_name: companyName,
      }),
      ...(acceptReferral && { referral }),
      ...(!isWellnessCampaignPage &&
        !isOldUserReactivationPage && { lead_via_partner_website: true }),
    };
    dispatch(saveLead({ data: apiData }))
      .then((res) => {
        onShowCallbackModal();
        setLeadData({ leadId: res?.payload?.lead_id, healthGoal: packSlug });
      })
      .catch(() => {});
  };

  const submitFreeTrial = () => {
    const coupon_code = (promoCode || "")?.toUpperCase();
    const apiData = {
      is_free_trial_requested: true,
      ...(showNameField && { name }),
      ...(showCVIDField && { club_vistara_id: cvid }),
      ...(showPhoneField && { phone_prefix: countryCode, mobile }),
      ...(showEmailField && { email }),
      ...(showCompanyNameField && { companyName }),
      package_slug: goal || data?.hero_signup_primary_pricing?.package_slug,
      ...(acceptReferral && { referral }),
      ...(!isWellnessCampaignPage &&
        !isOldUserReactivationPage && { lead_via_partner_website: true }),
      ...(coupon_code && { coupon_code: coupon_code }),
      urls_arguments: urlsArguments,
      timezone,
    };
    dispatch(postPackageSave({ router, data: apiData }));
  };

  const submitPackagePurchase = () => {
    const _inputs = {
      ...inputs,
      promoCode: isPromoCodeApplied && promoCode,
      goal: goal || data?.hero_signup_primary_pricing?.package_slug,
      urlsArguments,
      slug: goal || data?.hero_signup_primary_pricing?.package_slug,
    };

    const { amount, currency_code: currency } =
      data?.forms?.services?.[serviceActive || 0] || {};

    const _priceObj = {
      price: isPromoCodeApplied ? promoCodeData.new_price : amount,
      currency,
    };
    openPaymentPage(_inputs, _priceObj);
  };

  const onSubmit = () => {
    if (isWellnessCampaignPage) {
      const isNewPriceZero =
        isPromoCodeApplied && promoCodeData.new_price === 0;
      if (isNewPriceZero) {
        submitFreeTrial();
      } else {
        submitPackagePurchase();
      }
    } else {
      submitCallbackRequest();
    }
  };

  const primaryCTAData = useMemo(() => {
    if (isWellnessCampaignPage) {
      if (isPromoCodeApplied) {
        return {
          primaryText: "Try for Rs ",
          strikeThroughText: promoCodeData?.original_price,
          leadingText: " " + promoCodeData?.new_price,
        };
      } else {
        return {
          primaryText: `Try for Rs ${
            data?.forms?.services?.[serviceActive || 0]?.amount
          }`,
          strikeThroughText: null,
          leadingText: null,
        };
      }
    } else {
      return {
        primaryText: data?.forms?.button_text
          ? data?.forms?.button_text
          : "Submit",
        strikeThroughText: null,
        leadingText: null,
      };
    }
  }, [isWellnessCampaignPage, isPromoCodeApplied, serviceActive]);

  const FormInputsComp = (
    <FormInputs
      data={data}
      // State
      {...inputs}
      promoCode={promoCode}
      promoCodeError={promoCodeError}
      isLoading={isLoading}
      // isPackageFetching={isPackageFetching}
      isPromoCodeChecking={isPromoCodeChecking}
      isPromoCodeApplied={isPromoCodeApplied}
      promoCodeData={promoCodeData}
      removeAppliedPromoCode={removeAppliedPromoCode}
      // Actions
      handleChange={handleChange}
      handleSelectChange={handleSelectChange}
      handleBlur={(event) => handleBlur(event, onBlur)}
      onSubmitCallback={(isCallback) => onSubmitCallback(isCallback, onSubmit)}
      applyPromoCode={applyPromoCode}
      //
      goalOptions={!(data?.forms?.services?.length > 0) && staticGoalOptions}
      // packageOptions={packageOptions}
      // Show Fields
      showLabels={false}
      showNameField={showNameField}
      showCVIDField={showCVIDField}
      showPhoneField={showPhoneField}
      showEmailField={showEmailField}
      showCompanyNameField={showCompanyNameField}
      showGoalField={showGoalField && !defaultSelectedGoal}
      // showSelectPackage={showSelectPackage && !isPackageSelectedByDefault}
      showSelectPackage={showSelectPackage}
      showPromoCodeField={acceptCoupon}
      showReferralField={acceptReferral}
      // showSecondaryCTA={showSecondaryCTA}
      //
      // primaryCTA={generatePrimaryCTA()}
      // secondaryCTA={secondaryCTA}
      promoCodeButtonText={promoCodeButtonText}
      namePlaceHolder={namePlaceHolder}
      mobilePlaceholder={mobilePlaceholder}
      emailPlaceholder={emailPlaceholder}
      companyNamePlaceholder={companyNamePlaceholder}
      goalPlaceholder={goalPlaceholder}
      selectedPackagePlaceholder={selectedPackagePlaceholder}
      promoCodePlaceholder={promoCodePlaceholder}
      _services={_services}
      serviceActive={serviceActive}
      setServiceActive={setServiceActive}
      primaryCTAData={primaryCTAData}
    />
  );

  const SuccessModalComp = (
    <SuccessModal
      showButton={false}
      successImage={
        data?.forms?.image ||
        "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/Success.svg"
      }
      submissionTitle={
        data?.forms?.submission_title ||
        "Form submitted</br>Thank you for your interest."
      }
      submissionSubtitle={
        data?.forms?.submission_subtitle ||
        "Our team will get in touch within 24hrs. We look forward to welcoming you to our family &#128522;"
      }
      submissionExtraText={
        data?.forms?.submission_extra_text ||
        "Say farewell to unwell! #betheshyft"
      }
      leadData={leadData}
    />
  );

  return (
    <GradientSection>
      <TopContainer>
        <LHSSection isSmallScreen={width <= 1079} flexDirection="column">
          <LogoBox>
            {logoData?.partnerSrc && (
              <ImageBox
                src={logoData?.partnerSrc}
                maxHeight="42px"
                maxWidth="130px"
                objectFit="unset"
                mr="8px"
              />
            )}
            <Typography to={HOME_LINK} href={HOME_LINK} variant="link1">
              <StyledSvgSprite
                icon="icon-Shyft_Logo"
                height={width <= 767 ? "34px" : "42px"}
                width={width <= 767 ? "80px" : "92px"}
              />
            </Typography>
          </LogoBox>
          <TextAreaBox flexDirection="column">
            <DynamicContentHtml
              variant="display3"
              color={theme.colorsV2.primary.shade_800}
              isExtraBold
              mb="24px"
            >
              {data?.floating_banner?.title ||
                "Sign up and avail 20% OFF on Shyft's Health Programs"}
            </DynamicContentHtml>
            <Typography
              variant="heading4"
              color={theme.colorsV2.shyft.purple_text}
            >
              {data?.floating_banner?.subtitle ||
                "Combine the power of Nutrition and Exercise to reverse and manage your health conditions"}
            </Typography>
            <FlexDiv mt="24px" mx="-12px" flexWrap="wrap" width="100%">
              {data?.highlights?.map((item, index) => {
                return (
                  <Box maxWidth="95px" key={index} px="12px" mb="16px">
                    <FlexDiv
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <IconRing mb="8px">
                        <Image
                          src={item.img}
                          height="72px"
                          width="72px"
                          alt={item?.title}
                        />
                      </IconRing>
                      <Typography
                        variant="label2"
                        color={theme.colors.gray_100}
                        textAlign="center"
                      >
                        {item.title}
                      </Typography>
                    </FlexDiv>
                  </Box>
                );
              })}
            </FlexDiv>
          </TextAreaBox>
        </LHSSection>
        <RHSSection ref={topRef}>
          <FormBox flexDirection="column">
            <BlueBox flexDirection="column">
              <LogoBox mb="8px">
                {logoData?.formLogo && (
                  <ImageBox
                    src={logoData?.formLogo}
                    height="30px"
                    width="auto"
                    isObjectFit={false}
                    mr="8px"
                  />
                )}
                {logoData?.formLogo && logoData?.name === "Mastercard" && (
                  <StyledSeparator /> // TODO: Make this Separator Dynamic
                )}
                <StyledSvgSprite
                  icon="icon-shyft-logo-plain"
                  fill={theme.colors.white}
                  height="24px"
                  width="55px"
                />
              </LogoBox>
              <Typography variant="heading6" color={theme.colors.white}>
                {data?.floating_banner?.cta_title ||
                  data?.forms?.title ||
                  "Ready to make the Shyft ?"}
              </Typography>
              <Typography variant="paragraph3" color={theme.colors.white}>
                {data?.floating_banner?.description ||
                  data?.forms?.sub_title ||
                  "Fill the form and our Team will get back to you within 24 hrs."}
              </Typography>
            </BlueBox>
            <FormFieldBox>
              {showSuccessModal ? SuccessModalComp : FormInputsComp}
            </FormFieldBox>
          </FormBox>
        </RHSSection>
      </TopContainer>
    </GradientSection>
  );
}

export default TopSection;
